import { FC, type JSX } from 'react';

import useDC from '@eneco/dc/useDC';
import {
  GasIcon,
  ElectricityIcon,
  WarmthIcon,
  WaterIcon,
  ProfileIcon,
  VisibilityIcon,
  HomeIcon,
  ChatIcon,
  DotIcon,
  CalendarIcon,
  BoilerIcon,
  EnvelopeIcon,
  OrderPackageIcon,
} from '@eneco/sparky/icons';

import { DetailsIconType } from '../../types';

interface Props {
  type: DetailsIconType;
}

export const DetailsIcon: FC<Props> = ({ type }) => {
  const { label } = useDC();

  let icon: JSX.Element;

  switch (type) {
    case 'gas':
      icon = <GasIcon color="iconGas" />;
      break;

    case 'water':
      icon = <WaterIcon color="iconCooling" />;
      break;

    case 'heating':
      icon = <WarmthIcon color="iconHeat" />;
      break;

    case 'electricity':
      icon = <ElectricityIcon color="iconElectricity" />;
      break;

    case 'address':
      icon = <HomeIcon color={label === 'oxxio' ? 'iconBrand' : 'iconPrimary'} />;
      break;

    case 'profile':
      icon = <ProfileIcon color={label === 'oxxio' ? 'iconBrand' : 'iconPrimary'} />;
      break;

    case 'situation':
      icon = <VisibilityIcon color={label === 'oxxio' ? 'iconBrand' : 'iconPrimary'} />;
      break;

    case 'contact':
      icon = <ChatIcon color={label === 'oxxio' ? 'iconBrand' : 'iconPrimary'} />;
      break;

    case 'envelope':
      icon = <EnvelopeIcon color={label === 'oxxio' ? 'iconBrand' : 'iconPrimary'} />;
      break;

    case 'orderPackage':
      icon = <OrderPackageIcon color={label === 'oxxio' ? 'iconBrand' : 'iconPrimary'} />;
      break;

    case 'calendar':
      icon = <CalendarIcon color={label === 'oxxio' ? 'iconBrand' : 'iconPrimary'} />;
      break;

    case 'company':
      icon = <HomeIcon color={label === 'oxxio' ? 'iconBrand' : 'iconPrimary'} />;
      break;

    case 'boiler':
      icon = <BoilerIcon color={label === 'oxxio' ? 'iconBrand' : 'iconTotal'} />;
      break;

    default:
      icon = <DotIcon color="iconPrimary" />;
  }

  return icon;
};
